import MobileTopBar from "./MobileTopBar";
import MobileTabBar from "./MobileTabBar";

/**
 * Renders the mobile app chrome — sticky top bar and bottom tab bar.
 * The pages themselves render normally; on mobile we add bottom padding
 * via the global `.app-mobile-padding` utility so content clears the tab bar.
 */
const MobileAppShell = () => (
  <>
    <MobileTopBar />
    <MobileTabBar />
  </>
);

export default MobileAppShell;
